export const loanCalculatorData = [
  {
    id: 1,
    heading:
      "ICICI Bank Personal Loan EMI Calculator: Manage Your Finances with Confidence",
    subHeading:
      "Use the ICICI Bank Personal Loan EMI Calculator to effortlessly calculate your monthly payments, understand the total repayment cost, and make informed financial decisions. This tool helps you plan your personal loan repayment based on your loan amount, interest rate, and loan tenure. Knowing your EMI in advance gives you a clear idea of your financial commitments, helping you manage your budget effectively.",

    notice:
      "The calculations provided are for illustrative purposes only. Actual loan terms may vary based on the lender’s policies and your credit profile.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
